export default function Rodape() {
  return (
    <footer className="footer d-print-none d-flex justify-content-between align-items-center flex-wrap">
      <h2 className="text-center mx-auto">
        Diretoria da Tecnologia da Informação &copy;{' '}
        {new Date().getFullYear()} Defensoria Pública de Sergipe.
      </h2>
    </footer>
  );
}
